import $ from 'jquery'

$('#language-select').on('change', function () {
  window.location.href = $(this).val()
})

const header = document.querySelector('.site-header');

const setHeaderScroll = () => {
  const pos = window.pageYOffset;

  if (header != null) {
    if (pos === 0 && window.matchMedia('(min-width: 992px)').matches) {
      header.classList.add('site-header--top');
    } else {
      header.classList.remove('site-header--top');
    }
  }
};

window.addEventListener('load', setHeaderScroll);
window.addEventListener('scroll', setHeaderScroll);
window.addEventListener('resize', setHeaderScroll);

const jsContainer = () => {
  if ($('.js-container').length) {
    const bodyWidth = $('#primary').width()
    const ml = `calc(${-bodyWidth / 2}px + 50%)`

    $('.js-container').css({
      width: bodyWidth,
      marginLeft: ml,
    })
  }
}

$(window)
  .on('resize', function () {
    jsContainer()
  })
  .trigger('resize')

$('.go-top').on('click', function () {
  $('html, body').animate({scrollTop: 0}, 100);
})

$('.mouse').on('click', (function() {
  var targetOffset = $('.entry-content').offset().top;
  $('html, body').animate({
    scrollTop: targetOffset
  }, 100);
  })
);

const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('.site-header')
  const headerContainerHeight = headerContainer.clientHeight

  const vh = window.visualViewport.height

  body.style.setProperty(
      '--space-width',
      `${(documentWidth - mainContainerWidth) / 2 + 20 - 50}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)
  body.style.setProperty('--viewport-height', `${vh}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)
window.visualViewport.addEventListener('resize', setThemeVars)
